export default["__VITE_ASSET__SyoEl1kT__","__VITE_ASSET__PHFpA9qc__"];